// Entry point for the build script in your package.json
window.TOOLX = window.TOOLX || {}

import "@hotwired/turbo-rails"
import "./controllers"
import "./plugins"
